module.exports = __webpack_public_path__ + "static/media/Literate_KundeAvtale.a16235b6.pdf";